"use client";
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import AllCitiesPage from '../components/AllCities';

export default function AllCities() {
    return (
        <>
            <Navbar />
            <main className='bg-gray'>
                <AllCitiesPage />
            </main>
            <Footer />
        </>
    );
}
